import channelBox from "../../../assets/channels/channel-box.webp";
import instagramCard from "../../../assets/channels/instagram-card.png";
import messengerCard from "../../../assets/channels/messenger-card.png";
import tiktokCard from "../../../assets/channels/tiktok-card.webp";
import whatsappCard from "../../../assets/channels/whatsapp-card.png";
import xCard from "../../../assets/channels/x-card.webp";

/** Empty-state hero. The file already includes its floor shadow. */
export const CHANNEL_EMPTY_ARTWORK = channelBox;

export const CHANNEL_CARD_ARTWORK = {
  whatsapp: whatsappCard,
  facebook: messengerCard,
  instagram: instagramCard,
  tiktok: tiktokCard,
  x: xCard,
} as const;

export type ChannelCardArtworkId = keyof typeof CHANNEL_CARD_ARTWORK;
